export default __webpack_public_path__ + "static/2-59c5b49d9633959b6310453245a59092.jpg";